import * as GETTERS from '@/store/constants/getters.js';
import * as ROUTES from '@/constants/routes.js';
import { NEW_QUEUE, NEW_SEARCH } from '@/constants/lists.js';

export const getters = {
    [GETTERS.ALL_CLIENTS](state) {
        return state.clients;
    },
    [GETTERS.SITES_PER_CLIENT](state) {
        return (client_uuid) => state.clients[client_uuid].sites || [];
    },
    [GETTERS.CLIENT_BY_UUID](state) {
        return (client_uuid) => state.clients[client_uuid] || {};
    },
    [GETTERS.AVAILABLE_CLIENTS_LIST](state, getters) {
        const currentSearchUuid = getters[GETTERS.CURRENT_SEARCH_UUID];
        const currentRoute = getters[GETTERS.CURRENT_ROUTE];

        // We only need this on searches and new queues/searches so lets just return the whole list otherwise
        if (!currentSearchUuid && currentRoute !== ROUTES.NEW_QUEUE && currentRoute !== ROUTES.NEW_SEARCH) {
            return Object.values(state.clients);
        }

        let filters;

        if (currentSearchUuid) {
            filters = getters[GETTERS.SEARCH_BY_UUID](currentSearchUuid).filters;
        }
        if (currentRoute === ROUTES.NEW_QUEUE) {
            filters = getters[GETTERS.QUEUE_BY_UUID](NEW_QUEUE).filters;
        }
        else if (currentRoute === ROUTES.NEW_SEARCH) {
            filters = getters[GETTERS.SEARCH_BY_UUID](NEW_SEARCH).filters;
        }

        // Exclude clients that are already applied as filters.
        return Object.values(state.clients).filter((client) => !filters.find((filter) => filter.client_uuid === client.client_uuid));
    },
};
